import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import {Modal} from "../../../../../services/modal.service";
import {Api} from "../../../../../../common/services/api.service";
import {Api3Service} from "../../../../../../common/services/api3.service";
import {HelpersService} from "../../../../../../common/services/helpers.service";
import {SpinnerService} from "../../../../../../common/services/spinner.service";
import {AppStateService} from "../../../../../../common/services/app-state.service";
import {FormControl} from "@angular/forms";
import {takeUntil} from "rxjs";


@Component({
    selector: "section-custom-label-modal",
    template: `
        <div class="pull-right">
            <mat-slide-toggle [formControl]="multiple" *ngIf="show_multiple_button">
                Print multiple
            </mat-slide-toggle>

            <button mat-raised-button color="accent" (click)="print()" class="margin-left-20">
                <mat-icon>print</mat-icon>
                Print
            </button>

            <button mat-raised-button color="accent" (click)="edit()" *ngIf="modal.params.show_edit_button"
                    class="margin-left-20">
                <mat-icon>edit</mat-icon>
                Edit
            </button>

        </div>
        <h1 class="container-heading">Print label</h1>
        <mat-card *ngIf="labelSettings && labelsData">
            <mat-card-content #label>
                <div *ngFor="let data of labelsData" class="label">
                    <section-custom-label-renderer
                        [width]="labelSettings.size.width"
                        [height]="labelSettings.size.height"
                        [layout]="labelSettings.layout"
                        [data]="data"
                    ></section-custom-label-renderer>
                </div>

            </mat-card-content>
        </mat-card>
    `,
    styles: [
        `.label {
            margin-bottom: 20px
        }`
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelModalComponent implements OnInit, OnDestroy {

    protected destroy$: EventEmitter<boolean> = new EventEmitter(false);

    public modal: Modal.IModal;

    public labelSettings: any = {};

    public labelsData: any[] = [];

    @ViewChild("label", {static: false})
    public label: ElementRef;

    public multiple: FormControl = new FormControl(false);

    public show_multiple_button: boolean = false;

    public constructor(
        private api3Service: Api3Service,
        private changeDetectorRef: ChangeDetectorRef,
        private spinnerService: SpinnerService
    ) {
    }

    private async getLabelLayout(): Promise<any> {
        this.spinnerService.show();

        const {data}: Api.IResponse = await this.api3Service.get(
            `${AppStateService.getState().section}/custom-labels/${this.modal.params.label_id}`,
        );

        this.spinnerService.hide();

        if (data) {
            this.labelSettings = data;
            this.changeDetectorRef.markForCheck();
        }
    }

    private async getLabelData(id: number): Promise<any> {
        this.spinnerService.show();

        this.labelsData = [];

        let entity_url: string;
        switch (this.modal.params.type) {
            case "box":
                entity_url = "boxes";
                break;
            case "pallet":
                entity_url = "pallets";
                break;
            case "allocation":
                entity_url = "inventories/allocations";
                this.show_multiple_button = true;
                break;
            default:
                entity_url = "inventories";
                this.show_multiple_button = true;
                break;
        }

        const {data}: Api.IResponse = await this.api3Service.get(
            `${AppStateService.getState().section}/${entity_url}/${id}/label-data`,
        );

        this.spinnerService.hide();

        if (data) {
            let label_data: any = data;
            label_data.free_text = this.labelSettings.body;

            if (this.modal.params.data && this.modal.params.data[id]) {
                label_data = {
                    ...data,
                    ...this.modal.params.data[id]
                };
            }

            if (this.multiple.value && label_data.item_qty > 1) {
                for (let i = 1; i <= label_data.item_qty; i++) {
                    this.labelsData.push({...label_data, item_qty: 1});
                }
            } else {
                this.labelsData.push(label_data);
            }
            this.changeDetectorRef.markForCheck();
        }
    }

    public edit(): void {
        this.modal.response.emit({
            name: "edit",
            value: true
        });
    }

    public print(): void {
        const printContents: any = this.label.nativeElement.innerHTML;
        HelpersService.stickerPopUp(printContents);
    }


    public ngOnInit(): void {
        this.getLabelLayout().then(() => {
            for (const id of this.modal.params.ids) {
                this.getLabelData(Number(id));
            }
        });

        this.multiple.valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value: boolean) => {
                for (const id of this.modal.params.ids) {
                    this.getLabelData(Number(id));
                }
            });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

}
